import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const reports = (accountId, flags = {}) => ({
  parentNav: 'reports',
  routes: [
    'account_overview_reports',
    'advanced_monitoring',
    'conversation_reports',
    'omni_conversations_report',
    'csat_reports',
    'omni_csat_report',
    'bot_reports',
    'agent_reports',
    'omni_agents_report',
    'label_reports',
    'inbox_reports',
    'team_reports',
    'omni_teams_report',
    'reports_team_view',
    'reports_agent_view',
    'ticket_metrics_reports',
    'sla_reports',
    'reports_dashboard',
    'reports_report_builder',
    'reports_create_mode',
    'service_time_metrics_reports',
    'omni_service_time_metrics_report',
    'campaign_metrics_reports',
    'omni_campaign_metrics_report',
  ],
  menuItems: [
    {
      icon: 'arrow-trending-lines',
      label: 'REPORTS_OVERVIEW',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/overview`),
      toStateName: 'account_overview_reports',
    },
    {
      icon: 'data-histogram',
      label: 'ADVANCED_MONITORING',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/overview-2`),
      toStateName: 'advanced_monitoring',
    },
    {
      icon: 'chat',
      label: 'REPORTS_CONVERSATION',
      hasSubMenu: false,
      toState: flags.omniConversationsReport
        ? frontendURL(`accounts/${accountId}/reports/conversations-omni`)
        : frontendURL(`accounts/${accountId}/reports/conversation`),
      toStateName: flags.omniConversationsReport
        ? 'omni_conversations_report'
        : 'conversation_reports',
    },
    // Reports do Omni usam feature flag GLOBAL (Redis, gerenciada em
    // /super_admin/feature_flags). Os reports antigos do Explo eram gateados
    // por flag PER-ACCOUNT (custom_attributes['feature_flags']['explo'][...]).
    // Quando a flag global Omni está ON, dropamos o gate per-account: todas
    // as contas veem o item apontando pra rota Omni. Quando OFF, voltamos ao
    // fluxo padrão e o gate per-account decide a visibilidade.
    {
      icon: 'alarm',
      label: 'REPORTS_SERVICE_TIME_METRICS',
      hasSubMenu: false,
      toState: flags.omniServiceTimeMetricsReport
        ? frontendURL(
            `accounts/${accountId}/reports/service-time-metrics-omni`
          )
        : frontendURL(`accounts/${accountId}/reports/service-time-metrics`),
      toStateName: flags.omniServiceTimeMetricsReport
        ? 'omni_service_time_metrics_report'
        : 'service_time_metrics_reports',
      ...(flags.omniServiceTimeMetricsReport
        ? {}
        : { newFeatureFlag: 'explo.reports_dashboard' }),
    },
    {
      icon: 'megaphone',
      label: 'REPORTS_CAMPAIGN_METRICS',
      hasSubMenu: false,
      toState: flags.omniCampaignMetricsReport
        ? frontendURL(`accounts/${accountId}/reports/campaign-metrics-omni`)
        : frontendURL(`accounts/${accountId}/reports/campaign-metrics`),
      toStateName: flags.omniCampaignMetricsReport
        ? 'omni_campaign_metrics_report'
        : 'campaign_metrics_reports',
      ...(flags.omniCampaignMetricsReport
        ? {}
        : { newFeatureFlag: 'explo.reports_dashboard' }),
    },
    {
      icon: 'emoji',
      label: 'CSAT',
      hasSubMenu: false,
      toState: flags.omniCsatReport
        ? frontendURL(`accounts/${accountId}/reports/csat-omni`)
        : frontendURL(`accounts/${accountId}/reports/csat`),
      toStateName: flags.omniCsatReport
        ? 'omni_csat_report'
        : 'csat_reports',
    },
    {
      icon: 'bot',
      label: 'REPORTS_BOT',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.RESPONSE_BOT,
      toState: frontendURL(`accounts/${accountId}/reports/bot`),
      toStateName: 'bot_reports',
    },
    {
      icon: 'people',
      label: 'REPORTS_AGENT',
      hasSubMenu: false,
      toState: flags.omniAgentsReport
        ? frontendURL(`accounts/${accountId}/reports/agents-omni`)
        : frontendURL(`accounts/${accountId}/reports/agent`),
      toStateName: flags.omniAgentsReport
        ? 'omni_agents_report'
        : 'agent_reports',
      ...(flags.omniAgentsReport
        ? {}
        : {
            newFeatureFlag: 'explo.reports_dashboard',
            hideIfFeatureFlag: true,
          }),
    },
    {
      icon: 'tag',
      label: 'REPORTS_LABEL',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/label`),
      toStateName: 'label_reports',
      newFeatureFlag: 'explo.reports_dashboard',
      hideIfFeatureFlag: true,
    },
    {
      icon: 'mail-inbox-all',
      label: 'REPORTS_INBOX',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/inboxes`),
      toStateName: 'inbox_reports',
      newFeatureFlag: 'explo.reports_dashboard',
      hideIfFeatureFlag: true,
    },
    {
      icon: 'people-team',
      label: 'REPORTS_TEAM',
      hasSubMenu: false,
      toState: flags.omniTeamsReport
        ? frontendURL(`accounts/${accountId}/reports/teams-omni`)
        : frontendURL(`accounts/${accountId}/reports/teams`),
      toStateName: flags.omniTeamsReport
        ? 'omni_teams_report'
        : 'team_reports',
      ...(flags.omniTeamsReport
        ? {}
        : {
            newFeatureFlag: 'explo.reports_dashboard',
            hideIfFeatureFlag: true,
          }),
    },
    // When the global Omni flag is ON, hide the Explo variant (which would otherwise
    // show for accounts with `explo.reports_dashboard` enabled) — the Omni item above already covers it.
    ...(flags.omniTeamsReport
      ? []
      : [
          {
            icon: 'people-team',
            label: 'REPORTS_TEAM',
            hasSubMenu: false,
            toState: frontendURL(`accounts/${accountId}/reports/team-view`),
            toStateName: 'reports_team_view',
            newFeatureFlag: 'explo.reports_dashboard',
          },
        ]),
    ...(flags.omniAgentsReport
      ? []
      : [
          {
            icon: 'people-team',
            label: 'REPORTS_AGENT',
            hasSubMenu: false,
            toState: frontendURL(`accounts/${accountId}/reports/agent-view`),
            toStateName: 'reports_agent_view',
            newFeatureFlag: 'explo.reports_dashboard',
          },
        ]),
    {
      icon: 'arrow-download',
      label: 'REPORTS_TICKET_METRICS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/ticket_metrics`),
      toStateName: 'ticket_metrics_reports',
    },
    {
      icon: 'document-list-clock',
      label: 'REPORTS_SLA',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.SLA,
      toState: frontendURL(`accounts/${accountId}/reports/sla`),
      toStateName: 'sla_reports',
    },
    {
      icon: 'arrow-trending-lines',
      label: 'REPORT_BUILDER',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/report-builder`),
      toStateName: 'reports_report_builder',
      newFeatureFlag: 'explo.reports_report_builder',
    },
    {
      icon: 'graph-alt-2',
      label: 'CREATE_MODE',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/create-mode`),
      toStateName: 'reports_create_mode',
    },
  ],
});

export default reports;
